import { render, staticRenderFns } from "./dormRuleType.vue?vue&type=template&id=5d07a60e&scoped=true"
import script from "./dormRuleType.vue?vue&type=script&lang=js"
export * from "./dormRuleType.vue?vue&type=script&lang=js"
import style0 from "./dormRuleType.vue?vue&type=style&index=0&id=5d07a60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07a60e",
  null
  
)

export default component.exports